module.exports = __webpack_public_path__ + "static/people-logo-two-fe27cd029924bdefdf043f5b5c24ad6c.png";